import { createContext } from 'react';

export const InteractionContext = createContext();
